import { Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { UpdateFacs, Favorite, OrderCard } from '../core/models/facs.model';
import { FacsService } from './service/facs.service';
import { CheckTaskStatusService } from '../core/services/check-task-status-service/check-task-status-service';
import { EnvironmentService } from '../core/enviroment/environment.service';
import { FacsDefault, FacsTemp, FacsChanger, FacDashboard } from '../core/constants/facs-const';
import { SnackbarService } from '../shared/components/snackbar/service/snackbar.service';
import { IsLeaderService } from '../core/services/is-leader-service/is-leader.service';
import { ButtonsPopupService } from '../shared/components/buttons-popup/service/buttons-popup.service';
import { ButtonsPopupModel } from '../shared/components/buttons-popup/buttons-popup.model';
import { WindowScrollService } from '../core/services/window-scroll.service';
import { GoogleTagManagerService } from '../core/analytics/google-tag-manager.service';
import { CommunicationProxyService } from '../shared/services/communication-proxy.service';
import { CommunicationSubjectEnum } from '../shared/enum/communication-subject-enum';
import { EditFacModalService } from '../shared/components/edit-fac-modal/service/edit-fac-modal.service';

@Component({
  selector: 'app-facs',
  templateUrl: './facs.component.html',
  styleUrls: ['./facs.component.scss']
})
export class FacsComponent implements OnInit {

  @ViewChild('arrow_scroll') arrow_scroll: ElementRef;

  public form: FormGroup;
  public listDashboard = FacsDefault;
  public dragItem: {
    id: string,
    columnType: any
  };
  public loaderDash = {};

  public showFilter = false;
  public showDot = false;
  public openFilter = false;
  public showOpenDrop = false;
  public corp = false;
  public inCorp = false;
  public isFavorite = false;
  public flagInput = false;
  public isDrag = true;
  public showModal = false;
  public loader = false;
  public openList = false;
  public isArchived = false;
  public showFacs = false;
  public isSelect = false;
  public rowDown = false;
  public featureV2 = false;
  private isLoader = false;
  public isParam = false;
  public isCloseModalFeature = false;
  public featureTable = false;
  public featureInputSearch = false;
  public featureSwipe = this.environmentService.getEnvVar('feature_swipe_mobile') === 'true';
  public featureUnarchiveFac: boolean = this.environmentService.getEnvVar('feature_unarchive_fac') === 'true';

  public paramsRouterFromSearch = null;
  public paramsRouter = null;
  public isUuid = /[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}/;

  public listTemperature = FacsTemp;
  public listChanger = FacsChanger;
  public listStage = FacDashboard;
  public orderCardHorizontal: OrderCard = {
    above_fac_id: null,
    below_fac_id: null
  };

  public stageResponse = [];
  public listSearch = [];
  public tags = [];
  public ListToService = [];
  public listParams = [];
  public stageNumber = null;

  public textSearch = '';
  public text = '';
  public textField = '';

  public indexId = -1;
  public page = 0;
  public indexScroll = 0;
  public facsTour = window.localStorage.getItem('facs-tour-complete') === 'true';
  public featureTour = this.environmentService.getEnvVar('feature_fac_tour') === 'true';

  public clearOrder = false;
  public itemsSelected = [];
  public clearFilterRouter = false;
  public showTransferModal = false;

  public DELAY_AUTOCOMPLETE = 600;
  public requestForm = new FormControl();

  public isLeader = true;
  public showBulkErrorModal = false;
  public bulkErrorItems: any;
  public bulkErrorMessage: string;
  public showDiscardPopup = false;

  public showToFileButton: boolean;

  private columnSourceIndex?: number;

  private facStatus?: string;

  public readonly popupArchive: ButtonsPopupModel = {
    title: 'Arquivar facs',
    description:
      'Você tem certeza que deseja arquivar estas facs? Facs arquivadas podem ser acessadas utilizando o filtro de facs arquivadas.',
    buttons: [
      {
        btnType: 3,
        title: 'Cancelar',
        func: () => this.closeBulkArchiveModal()
      },
      {
        btnType: 1,
        title: 'Arquivar',
        func: () => this.archiveSelectedFacs()
      }
    ]
  };

  @HostListener('document:click', ['$event'])
  onClick(ev: Event) {
    if (this.flagInput && this.listSearch.length) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.listSearch = [];
        this.flagInput = false;
      }
    }
  }

  constructor(
    public service: FacsService,
    private serviceIsLeader: IsLeaderService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private eRef: ElementRef,
    private checkStatusService: CheckTaskStatusService,
    private environmentService: EnvironmentService,
    private snackbarService: SnackbarService,
    private btnService: ButtonsPopupService,
    private windowScroll: WindowScrollService,
    private googleTagService: GoogleTagManagerService, 
    private communicationProxyService: CommunicationProxyService,
    private facModalService: EditFacModalService,
  ) { }

  ngOnInit() {
    this.showFacs = true;
    this.featureTable = this.environmentService.getEnvVar('feature_table') === 'true';
    this.featureInputSearch = this.environmentService.getEnvVar('feature_input_search') === 'true';
    this.initForm();
    this.requestFacId(this.getfacIdFromUrl(this.router.url));
    this.trackOrigin();
    this.router.navigate(
      [],
      {
        queryParams: { id: null },
        queryParamsHandling: 'merge'
      });
    this.localStoragePosition();
    this.checkIsLeader();
    this.route.queryParams.subscribe(x => {
      if (x === null) {
        this.form.get('isFavorite').setValue(null);
      }
      this.openLinkModal(x);
      this.dataForm(x);
      this.requestActiveRouter(x);
      this.validatorUser();
      this.paramsValid();
      this.paramsOperation();
    });
    this.tourFac();
    this.searchInput();
    this.verifyFlag();
    this.communicationProxyService.subscribe(CommunicationSubjectEnum.onFacUpdated, (payload) => {this.facStatus = payload.message})
  }

  public verifyFlag() {
    this.route.queryParams.subscribe(x => {
      if (this.paramsRouter.archived === true) {
        this.showToFileButton = true;
      } else {
        this.showToFileButton = false;
      }
    });

  }

  public scrollLeft(): void {
    this.arrow_scroll.nativeElement.scrollLeft -= 314;
  }

  public scrollRight(): void {
    this.arrow_scroll.nativeElement.scrollLeft += 314;
  }

  private checkIsLeader() {
    if (this.environmentService.getEnvVar('feature_check_is_leader_fac') === 'true') {
      this.serviceIsLeader.getIsLeader().subscribe(isLeader => this.isLeader = isLeader);
    }
  }

  private tourFac(): void {
    if (!this.facsTour && this.featureTour) {
      this.paramsRouter.user_id != null ? this.router.navigate([`/facs-tour`],
        {
          queryParams:
          {
            user_id: this.paramsRouter.user_id,
            user_type: this.paramsRouter.user_type,
            user_nickname: this.paramsRouter.user_nickname,
            user_name: this.paramsRouter.user_name
          }
        }) : this.router.navigate([`/facs-tour`]);
      return;
    }
  }

  private requestActiveRouter(x: any): void {
    this.paramsRouter = {
      fields: this.textSearch ? this.textSearch : null,
      color: x.vencimentos ? this.validateColorId(x.vencimentos) : null,
      temperature: x.temperatura ? x.temperatura.toLowerCase() : null,
      is_favorite: this.form.get('isFavorite').value ? this.form.get('isFavorite').value : null,
      badges: {
        name: this.isBadges(x.incorporador).corp,
        flag: this.isBadges(x.incorporador).flag
      },
      archived: this.form.get('archived').value ? this.form.get('archived').value : null,
      ranges: this.getItem(x),
      user_type: x.user_type ? x.user_type : null,
      user_id: x.user_id ? x.user_id : null,
      user_nickname: x.user_nickname ? x.user_nickname : null,
      user_name: x.user_name ? x.user_name : null,
    };
    this.clearFilterActiveRouter();
  }

  private clearFilterActiveRouter(): void {
    this.clearFilterRouter = false;
    if (this.paramsRouter.fields === null && this.paramsRouter.color === null && this.paramsRouter.temperature === null &&
      !this.paramsRouter.is_favorite && this.paramsRouter.badges.name === null && this.paramsRouter.archived === null &&
      !this.paramsRouter.ranges.length && this.paramsRouter.user_id === null && this.paramsRouter.user_nickname === null &&
      this.paramsRouter.user_name === null) {
      this.clearFilterRouter = false;
      this.resetForm();
    } else {
      this.clearFilterRouter = true;
    }
  }

  private paramsOperation(): void {
    if (this.openList) {
      if (this.featureTable) {
        this.getScroll({ index: 1 });
      } else {
        this.getScroll(1);
      }
    } else {
      this.dataSearch(this.ListToService, 0, 0);
    }
  }

  private validatorUser() {
    if (this.paramsRouter.user_id !== null) {
      this.ListToService = [{
        values: [this.paramsRouter.user_id],
        field: 'user.id'
      }];
      this.tags.push({
        type: this.paramsRouter.user_type,
        field: 'user.id',
        value: this.formatStrong(this.paramsRouter.user_id),
        description: this.formatStrong(this.paramsRouter.user_nickname + ' - ' + this.paramsRouter.user_name)
      });
      this.dataSearch(this.ListToService, 0, 0);
    }
  }

  private getItem(x: any) {
    const dateRanges = [];
    if (x.create_date) {
      dateRanges.push(JSON.parse(x.create_date));
    }
    if (x.update_date) {
      dateRanges.push(JSON.parse(x.update_date));
    }
    if (x.distribution_date) {
      dateRanges.push(JSON.parse(x.distribution_date));
    }
    return dateRanges;
  }

  private requestFacId(facId: string) {
    if (this.isUuid.test(facId)) {
      this.dragItem = { id: facId, columnType: { value: null } };
      this.showModal = true;
      this.featureTour = false;
    }
  }

  private openLinkModal(data): void {
    if (data && data.id && data.id !== null) {
      const valueLink = {
        event: {
          id: data.id,
          openModal: true,
        },
        column: {
          value: null,
          sub_items: []
        },
      };
      this.openModal(valueLink);
    }
  }

  public getfacIdFromUrl(url: string) {
    url = url.replace('/facs?id=', '');
    return url;
  }

  public initForm() {
    this.form = this.fb.group({
      temp: [null],
      late: [null],
      isFavorite: [null],
      corporator: [null],
      notCorporator: [null],
      archived: [null],
      createTime: [null],
      updateTime: [null],
      distributionTime: [null]
    });
  }

  public localStoragePosition() {
    if (localStorage.getItem('position') !== 'table') {
      this.openList = false;
    } else {
      this.openList = true;
    }
  }

  public changeView() {
    this.openList = !this.openList;
    if (this.openList) {
      localStorage.setItem('position', 'table');
      if (this.featureTable) {
        this.getScroll({ index: 1 });
      } else {
        this.getScroll(1);
      }
    } else {
      localStorage.setItem('position', 'dashboard');
      this.listDashboard = FacsDefault;
      this.listStage = [{
        stage: 0,
        page_number: 1,
        page_items: 30
      },
      {
        stage: 1,
        page_number: 1,
        page_items: 30
      },
      {
        stage: 2,
        page_number: 1,
        page_items: 30
      },
      {
        stage: 3,
        page_number: 1,
        page_items: 30
      },
      {
        stage: 4,
        page_number: 1,
        page_items: 30
      },
      {
        stage: 5,
        page_number: 1,
        page_items: 30
      }];
      this.dataSearch(this.ListToService, 0, 0);
    }
  }

  public drop(event: CdkDragDrop<string[]>, column: any) {
    this.dragItem = null;
    this.isDrag = true;
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.showModal = false;

      // NEW UPDATE FACS
      const index = event.container.data.indexOf(event.container.data[event.currentIndex]);
      this.updateFacs({
        id: event.container.data[index]['id'],
        stage: {
          above_fac_id: event.container.data[index - 1] ? event.container.data[index - 1]['id'] : null,
          below_fac_id: event.container.data[index + 1] ? event.container.data[index + 1]['id'] : null
        }
      });
      event.currentIndex = null;
    } else {

      this.columnSourceIndex = this.extractIndexColumnFromDragDrop(event.previousContainer.id);

      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      const index = event.container.data.indexOf(event.container.data[event.currentIndex]);
      this.orderCardHorizontal = {
        above_fac_id: event.container.data[index - 1] ? event.container.data[index - 1]['id'] : null,
        below_fac_id: event.container.data[index + 1] ? event.container.data[index + 1]['id'] : null
      };
      this.dragItem = {
        id: event.container.data[event.currentIndex]['id'],
        columnType: column
      };
      
      const facNumber = event.container.data[event.currentIndex]['fac_number'];
      this.sendGATagOnChangeFunnel(column.value, facNumber);
      
      event.currentIndex = null;
      this.flagInput = false;
      this.showModal = true;
    }
  }

  private extractIndexColumnFromDragDrop(dragDropId: string): number {
    const matchValues = dragDropId.match(/\d+/);
    return matchValues.length > 0 ? +matchValues[0] : null;
  }

  public dataForm(data) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        this.requestParams(data);
      }
    }
  }

  private requestParams(data: any): void {
    if (data.favoritos) {
      this.form.get('isFavorite').setValue(true);
    }
    if (data.temperatura) {
      this.form.get('temp').setValue(data.temperatura);
    }
    if (data.vencimentos) {
      this.form.get('late').setValue(data.vencimentos);
    }
    if (data.arquivados) {
      this.form.get('archived').setValue(true);
    }
    if (data.create_date) {
      this.form.get('createTime').setValue(JSON.parse(data.create_date));
    }
    if (data.update_date) {
      this.form.get('updateTime').setValue(JSON.parse(data.update_date));
    }
    if (data.distribution_date) {
      this.form.get('distributionTime').setValue(JSON.parse(data.distribution_date));
    }

  }

  public dataList(data: any[]) {
    if (data.length) {
      data.forEach(col => {
        if (col.facs.length) {
          col.facs.forEach((fac: any) => {
            this.validColor(fac);
            this.validTemperature(fac);
          });
        }
      });
    }
  }

  public validColor(color: { color: any; }) {
    color.color = Number(color.color);
    if (!color.color || (color.color !== 1 && color.color !== 2 && color.color !== 3)) {
      color.color = 1;
    }
  }

  public validTemperature(dataTemp: { temperature: any; isCall: any; interest?: any; }) {
    if (dataTemp.temperature || dataTemp.interest) {
      dataTemp.isCall = true;
    } else {
      dataTemp.isCall = false;
    }
  }

  public pointerSelection(data: number) {
    this.indexId = data;
  }

  public updateFacs(currentIndex: UpdateFacs) {
    this.service.updateFacs(currentIndex).subscribe(() => currentIndex = null, () => null);
  }

  public eventDrag(event: boolean) {
    this.isDrag = event;
  }

  public updateFavorite(data: Favorite) {
    let dataNumber = this.stageNumber;
    if (dataNumber != null) {
      this.stageNumber = null;
    }
    this.service.puthFavorite(data).subscribe((x: any) => {
      this.checkStatusService.checkTaskStatus(x.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(() => {
        if (!this.ListToService.length) {
          if (!data.is_favorite && this.form.get('isFavorite').value) {
            this.listUpdatingFavorite(dataNumber, data.id);
            this.service.filterv2(this.paramsRouter, 0, 0, this.ListToService, this.listStage, this.openList).subscribe((resp: any) => {
              this.stageResponse = resp.paginations;
              dataNumber = null;
            });
          }
        }
      });
    });
  }

  public clearSearch() {
    this.requestForm.setValue('');
    this.flagInput = false;
    this.indexId = -1;
  }

  private listUpdatingFavorite(dataNumber: number, data: string): void {
    const dataRest = Object.assign({}, this.listDashboard[dataNumber]);
    this.listDashboard[dataNumber].facs = [];
    dataRest.facs.forEach((x, i) => {
      if (x.id === data) {
        this.listDashboard[dataNumber].facs.splice(i, 1);
      } else {
        this.listDashboard[dataNumber].facs.push(x);
      }
    });
  }

  public getPosition(data: number) {
    this.stageNumber = data;
  }

  public closeModal() {
    this.showModal = false;
    this.isCloseModalFeature = true;
    if(this.facStatus && this.facStatus !== '') {
      this.requestClosedModalStatusUpdated(this.facModalService.getColumnType(this.facStatus) - 1);
    } else {
      this.requestClosedModal();
    }
  }

  private requestClosedModalStatusUpdated(columnTargetIndex: number) {
    const columnSourceIndex = this.listRequest();
    this.updateSourceAndTargetDashboardColumns(columnSourceIndex, columnTargetIndex);
  }

  private requestClosedModal() {
    const columnTargetIndex = this.listRequest();
    this.updateSourceAndTargetDashboardColumns(this.columnSourceIndex, columnTargetIndex);
  }

  private updateSourceAndTargetDashboardColumns(sourceIndex: number, targetIndex: number) {

    this.listStage[targetIndex].page_number = 1;
    this.listStage[targetIndex].page_items = this.listDashboard[targetIndex].facs.length;

    this.service.filterv2(this.paramsRouter, 0, 0, this.ListToService, this.listStage, this.openList).subscribe((resp: any) => {

      this.updateDashboardColumn(resp.payload, sourceIndex)
      this.updateDashboardColumn(resp.payload, targetIndex)
      
      this.dataList(this.listDashboard);
      this.stageResponse = resp.paginations;

    });
  }

  private listRequest(): number {
    const dataNumber = this.stageNumber;
    if (dataNumber != null) {
      this.stageNumber = null;
    }
    this.stageResponse.forEach((x, i) => {
      this.listStage[i].page_items = x.page_items;
      this.listStage[i].page_number = x.page_number;
    });
    return dataNumber;
  }

  private updateDashboardColumn(updatedColumns, columnIndex) {
    if(columnIndex !== undefined) {
      const facs = updatedColumns[columnIndex].facs;
      this.listDashboard[columnIndex].facs = [...new Set(facs)];
    }
  }

  public openModal(data: { event: any; column: any; }) {
    this.dragItem = {
      id: data.event.id,
      columnType: data.column
    };
    const { openModal } = data.event;
    this.flagInput = false;
    this.showModal = openModal;
  }

  public openTable(event) {
    this.dragItem = {
      id: event.id,
      columnType: event.column
    };
    this.showModal = event.openModal;
    this.flagInput = false;
  }


  public searchInput() {
    this.requestForm.valueChanges.pipe(
      debounceTime(this.DELAY_AUTOCOMPLETE),
      distinctUntilChanged(),
    ).subscribe(text => this.requestSearch(text));
  }

  private requestSearch(data: string): void {
    this.textSearch = this.formatStrong(data);
    if (data && data.length >= 3) {
      this.flagInput = true;
      this.service.autoComplete(data).subscribe(resp => {
        this.listSearch = resp;
      });
    } else {
      this.flagInput = false;
      this.indexId = -1;
    }
  }

  public noRefreshSearch() {
    this.flagInput = false;
    if (this.indexId >= 0) {
      this.alteredCarbom();
    } else {
      if (this.textSearch.length === 1 || this.textSearch.length === 2) {
        return false;
      } else {
        this.searchText();
      }
    }
  }


  public searchText() {
    if (this.textSearch.length >= 3 || this.ListToService.length) {
      this.listSearch = [];
      this.paramsRouter.fields = this.textSearch;
      this.clearOrder = true;
      this.dataSearch(this.ListToService, 0, 0);
      this.flagInput = false;
    } else {
      if (this.openTable) {
        this.dataSearch(this.ListToService, this.indexScroll, 50);
        return false;
      }
      this.paramsRouter.fields = this.textSearch;
      this.flagInput = false;
      this.requestClosedModal();
      this.tags = [];
    }
  }

  public showFilterAction() {
    this.showFilter = !this.showFilter;
  }

  public tempData(event: { name: any; }) {
    this.form.get('temp').setValue(event.name);
  }

  public changeData(event: { name: any; }) {
    this.form.get('late').setValue(event.name);
  }

  public validatorDot(): boolean {
    if (this.form.get('temp').value || this.form.get('late').value ||
      this.form.get('isFavorite').value || this.form.get('corporator').value ||
      this.form.get('notCorporator').value || this.form.get('archived').value ||
      this.form.get('createTime').value || this.form.get('updateTime').value ||
      this.form.get('distributionTime').value
    ) {
      this.showDot = true;
    } else {
      this.showDot = false;
    }
    return this.showDot;
  }

  private paramsValid() {
    if (this.paramsRouter.archived !== null
      || this.paramsRouter.color !== null || this.paramsRouter.fields !== null
      || this.paramsRouter.is_favorite !== null || this.paramsRouter.temperature !== null
      || this.paramsRouter.badges.name !== null || this.paramsRouter.ranges.length > 0) {
      this.isParam = true;
    } else {
      this.isParam = false;
    }
  }

  public selectField(): void {
    this.isFavorite = !this.isFavorite;
    this.form.get('isFavorite').setValue(this.isFavorite);
  }

  public selectArchived(): void {
    this.isArchived = !this.isArchived;
    this.form.get('archived').setValue(this.isArchived);
  }

  public enableAction(): void {
    this.showToFileButton = !this.showToFileButton;
    this.form.get('archived').setValue(this.showToFileButton);
  }


  public selectIncorporator() {
    this.corp = !this.corp;
    this.inCorp = false;
    this.form.get('corporator').setValue(this.corp);
    this.form.get('notCorporator').setValue(this.inCorp);
  }

  public selectNotCorp() {
    this.inCorp = !this.inCorp;
    this.corp = false;
    this.form.get('corporator').setValue(this.corp);
    this.form.get('notCorporator').setValue(this.inCorp);
  }

  public resetForm() {
    this.isFavorite = false;
    this.isArchived = false;
    this.inCorp = false;
    this.corp = false;
    this.form.reset();
  }

  public initFormRouter() {
    this.showFilter = false;
    this.router.navigate([`/facs`], {
      queryParams: {
        temperatura: this.form.get('temp').value,
        vencimentos: this.form.get('late').value,
        favoritos: this.form.get('isFavorite').value ? this.form.get('isFavorite').value : null,
        incorporador: this.validCorp(),
        arquivados: this.form.get('archived').value ? this.form.get('archived').value : null,
        create_date: this.form.get('createTime').value ? JSON.stringify(this.form.get('createTime').value) : null,
        update_date: this.form.get('updateTime').value ? JSON.stringify(this.form.get('updateTime').value) : null,
        distribution_date: this.form.get('distributionTime').value ? JSON.stringify(this.form.get('distributionTime').value) : null
      }
    });
  }

  public validCorp(): boolean {
    let isCorp = null;
    if (this.form.get('corporator').value) {
      isCorp = 'Sim';
    }
    if (this.form.get('notCorporator').value) {
      isCorp = 'Nao';
    }
    return isCorp;
  }

  public alteredCarbom() {
    if (this.indexId > -1 && this.textSearch.length >= 3) {
      this.searchTags(this.listSearch[this.indexId]);
      this.flagInput = false;
      this.indexId = -1;
    }
  }

  public downList(event: Event | any) {
    if (event.keyCode === 27) {
      this.flagInput = false;
      return false;
    }
    if ((event.keyCode === 40 || event.keyCode === 38)) {
      if (this.indexFilter(this.indexId, this.listSearch.length, event, 40, 38)) {
        return false;
      }
      this.validIndex(event.keyCode);
    }
  }

  public validIndex(data: number) {
    if (data === 40) {
      this.indexId += 1;
      this.textSearch = this.formatStrong(this.listSearch[this.indexId].description);
      return false;
    }
    if (data === 38) {
      this.indexId -= 1;
      this.textSearch = this.formatStrong(this.listSearch[this.indexId].description);
      return false;
    }
  }

  public indexFilter(index: number, listLength: number, event, numberDown: number, numberUp: number) {
    if ((index + 1 >= listLength) && event.keyCode === numberDown) {
      return true;
    }
    if ((index <= 0) && event.keyCode === numberUp) {
      return true;
    }
    return false;
  }

  public formatStrong(data: string): string {
    return data.replace(/<strong>/g, '').replace(/<\/strong>/g, '');
  }

  public validateColorId(data: string) {
    let colorId = null;
    switch (data.toLowerCase()) {
      case 'verde':
        colorId = 1;
        break;
      case 'vermelho':
        colorId = 2;
        break;
      case 'amarelo':
        colorId = 3;
        break;
    }
    return colorId;
  }

  public removeTags(data: string, index: number) {
    this.ListToService.forEach((x, i) => {
      if (x.values.find((a: any) => a === data)) {
        this.tags.splice(index, 1);
        x.values.splice(x.values.indexOf(data), 1);
      }
      if (!x.values.length) {
        this.ListToService.splice(i, 1);
      }
    });
    this.lengthListSearch();
  }

  public lengthListSearch() {
    if (this.ListToService.length) {
      this.validatorTable();
    } else {
      this.requestForm.setValue('');
      this.validatorTable();
    }
  }

  private validatorTable() {
    if (this.openList) {
      this.dataSearch(this.ListToService, this.indexScroll, 50);
    } else {
      this.dataSearch(this.ListToService, 0, 0);
    }
  }

  public searchTags(item) {
    let listAlteranative = {};
    this.ListToService = [];
    this.flagInput = false;
    this.textSearch = '';
    this.requestForm.setValue('');

    this.carbomList(this.tags, item.description);
    this.tags.push({
      type: item.type,
      field: item.field,
      value: this.formatStrong(item.description),
      description: this.formatStrong(item.label)
    });
    this.clearOrder = true;
    this.listAlteredCarbom(this.tags, listAlteranative);
    this.alterdCarbom(listAlteranative, this.ListToService, item.type);
    this.dataSearch(this.ListToService, 0, 0);
    this.textField = null;
  }

  public carbomList(list: any[], data: string) {
    if (list.length > 0) {
      list.forEach((x, i: number) => {
        if (this.formatStrong(data).toLocaleLowerCase() === x.value.toLocaleLowerCase()) {
          list.splice(i, 1);
        }
        if (this.formatStrong(data).toLocaleLowerCase() === x.description.toLocaleLowerCase()) {
          list.splice(i, 1);
        }
      });
    }
  }

  private alterdCarbom(clone: { [x: string]: any; hasOwnProperty?: any; }, listOrigin: any[], type: string) {
    for (const key in clone) {
      if (clone.hasOwnProperty(key)) {
        listOrigin.push({
          values: clone[key],
          field: key,
          type
        });
      }
    }
  }

  public listAlteredCarbom(listOrigin: any[], listClone: { [x: string]: any[]; }) {
    listOrigin.forEach(x => {
      if (listClone[x.field] !== undefined) {
        listClone[x.field] = [...listClone[x.field], x.value];
      } else {
        listClone[x.field] = [x.value];
      }
    });
  }

  public isBadges(data: string): { corp: string, flag: boolean } {
    let corp = null;
    let flag = false;
    switch (data) {
      case 'Sim':
        corp = this.returnIsBadges(true).innerValue;
        flag = this.returnIsBadges(true).isBadges;
        break;
      case 'Nao':
        corp = this.returnIsBadges(false).innerValue;
        flag = this.returnIsBadges(false).isBadges;
        break;
      default:
        corp = null;
        flag = false;
        break;
    }
    return { corp, flag };
  }

  public returnIsBadges(data: boolean): { isBadges: boolean, innerValue: string } {
    this.form.get('corporator').setValue(data);
    this.form.get('notCorporator').setValue(!data);
    return { isBadges: data, innerValue: 'REAL_STATE_DEVELOPER_SELLER' };
  }

  public dataSearch(list: any[], index: number, pageNumber: number, order?: any[]) {
    // tslint:disable-next-line: max-line-length
    this.paramsRouterFromSearch ? (this.paramsRouter.fields = this.paramsRouterFromSearch) : (this.paramsRouter.fields = this.requestForm.value);
    let listParams = [];
    if (list && list.length) {
      listParams = list;
    }
    this.service.filterv2(this.paramsRouter, index, pageNumber, listParams, [], this.openList, order).subscribe((response: any) => {
      this.listStage = FacDashboard;
      if (this.openList) {
        this.page = response.page_info.total_pages ? response.page_info.total_pages : 1;
      }
      this.listDashboard = response.payload;
      this.stageResponse = response.paginations;
      this.dataList(this.listDashboard);
      this.service.setList(response);
      this.showFacs = false;
      this.clearOrder = false;
      if (!this.clearFilterRouter) {
        this.validatorDot();
      }
    }, (err) => {
      if (err.status === 400 && err.error.messages[0]) {
        this.snackbarService.show(err.error.messages[0].message, 'error');
      }
      this.showFacs = false;
    });
  }

  public getScroll(event) {
    if (this.featureTable) {
      this.indexScroll = event.index;
    } else {
      this.indexScroll = event;
    }
    if (this.indexScroll === null && this.openTable) {
      this.indexScroll = 1;
    }
    const count = event?.data && event.data.listLength ? event.data.listLength : 50;
    const order = event?.data && event.data.order ? event.data.order : null;
    if (order != null) {
      this.loaderAct(event.index);
      this.dataSearch(this.ListToService, this.indexScroll, count, order);
    } else {
      this.loaderAct(event);
      this.dataSearch(this.ListToService, this.indexScroll, count);
    }
  }

  public loaderAct(dataIndex: number) {
    if (dataIndex >= this.page) {
      return false;
    }
  }

  public scroll(event: Event | any, stage: number) {
    event.preventDefault();
    const heigth = ((100 * event.srcElement.scrollTop) / (event.srcElement.scrollHeight - event.srcElement.clientHeight));
    if (heigth >= 99) {
      this.validatorRequest(stage);
    }
  }

  private validatorRequest(stage: number): void {
    if (this.stageResponse[stage].page_number >= this.stageResponse[stage].total_pages) {
      this.loaderDash[stage] = false;
    }
    if (this.isLoader || this.isCloseModalFeature) {
      this.isCloseModalFeature = false;
      return;
    } else {
      this.isLoader = true;
      this.requestColumn(stage, this.stageResponse[stage].page_number + 1);
    }
  }

  public requestColumn(stage: number, increment: number): void {
    this.stageNumber = stage;
    this.listStage[stage] = {
      stage,
      page_number: increment,
      page_items: 30
    };
    const request = this.listStage[stage];
    if (this.listDashboard[stage].facs.length >= 30) {
      this.loaderDash[stage] = true;
    }
    this.service.filterv2(this.paramsRouter, 0, 0, this.ListToService, [request], this.openList).subscribe((resp: any) => {
      resp.payload[stage].facs.forEach((x: any) => this.listDashboard[stage].facs.push(x));
      this.stageResponse[stage] = resp.paginations[0];
      this.loaderDash[stage] = false;
      this.isLoader = false;
    });
  }


  public getFacIds(itemsSelected: []) {
    this.itemsSelected = itemsSelected;
  }


  public transferFac(data) {
    const dataFac = {
      fac_ids: this.itemsSelected,
      destination_user: data
    };
    this.service.postFacPackTransfer(dataFac).subscribe((resp: any) => {
      this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe((taskRes: any) => {
        this.snackbarService.show('A transferência está em processamento', 'success');
        if (taskRes.status.id === 1) {
          if (dataFac.fac_ids.length === 1) {
            this.snackbarService.show('A fac foi transferida com sucesso', 'success');
          } else {
            this.snackbarService.show('As facs foram transferidas com sucesso', 'success');
          }
          this.paramsOperation();
          this.isSelect = false;
        }
        if (taskRes.status.id === 2) {
          // tslint:disable-next-line: max-line-length
          this.messageResp(taskRes.metadata.facs_with_errors, 'Atenção: houve um problema e as seguintes facs não puderam ser transferidas');
        }
      });
    });
  }

  public messageResp(resp: any[], msg: string) {
    this.bulkErrorItems = resp;
    this.bulkErrorMessage = msg;
    this.showBulkErrorModal = true;
  }

  showBulkArchiveModal(): void {
    this.windowScroll.disable();
    this.btnService.show(this.popupArchive);
  }

  closeBulkArchiveModal(): void {
    this.windowScroll.enable();
    this.showTransferModal = false;
  }

  archiveSelectedFacs(): void {
    const dataFac = {
      fac_ids: this.itemsSelected,
      archived: true
    };
    this.service.postFacBulkArchive(dataFac).subscribe((resp: any) => {
      this.snackbarService.show('O arquivamento foi iniciado', 'success');
      this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe((taskRes: any) => {
        if (taskRes.status.id === 1) {
          this.snackbarService.show('O arquivamento foi concluído com sucesso', 'success');
          this.dataSearch(this.ListToService, this.indexScroll, 50);
          this.paramsOperation();
          this.isSelect = false;
        }
        if (taskRes.status.id === 2) {
          this.messageResp(taskRes.metadata.facs_with_errors, 'Atenção: houve um problema e as seguintes facs não foram arquivadas');
        }
      });
    });
  }

  unarchiveSelectedFacs(): void {
    const dataFac = {
      fac_ids: this.itemsSelected,
      archived: false
    };
    this.service.postFacBulkArchive(dataFac).subscribe((resp: any) => {
      this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe((taskRes: any) => {
        this.snackbarService.show('O desarquivamento foi iniciado', 'success');
        if (taskRes.status.id === 1) {
          if (dataFac.fac_ids.length === 1) {
            this.snackbarService.show('A fac foi desarquivada', 'success');
          } else {
            this.snackbarService.show('As facs foram desarquivadas', 'success');
          }
          this.dataSearch(this.ListToService, this.indexScroll, 50);
          this.paramsOperation();
          this.isSelect = false;
        }
        if (taskRes.status.id === 2) {
          this.messageResp(taskRes.metadata.facs_with_errors, 'Atenção: Houve um problema e as seguintes FACs não foram desarquivadas.');
        }
      });
    });
  }

  showBulkDiscard(): void {
    this.windowScroll.disable();
    this.showDiscardPopup = true;
  }

  closeBulkDiscard(): void {
    this.windowScroll.enable();
    this.showDiscardPopup = false;
  }

  discardSelectedFacs(modalData: any): void {
    let dataFacs = {
      fac_ids: this.itemsSelected,
      discarded: true,
      reason: modalData.reason,
      observation: modalData.observation
    };
    this.closeBulkDiscard();
    this.service.postFacBulkDiscard(dataFacs).subscribe((resp: any) => {
      this.snackbarService.show('O descarte foi iniciado', 'success');
      this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe((taskRes: any) => {
        if (taskRes.status.id === 2) {
          this.messageResp(taskRes.metadata.facs_with_errors, 'Atenção: houve um problema e as seguintes facs não foram descartadas');
        } else {
          this.snackbarService.show('O descarte foi concluído com sucesso', 'success');
          this.dataSearch(this.ListToService, this.indexScroll, 50);
          this.paramsOperation();
          this.isSelect = false;
        }
      });
    });
    if (dataFacs.discarded) {
      dataFacs.fac_ids.length = 0;
    }
  }

  private trackOrigin(): void {
    this.route.queryParams.subscribe(param => {
      if (param.origin != null && param.source != null) {
        this.sendTrackingSourceOrigin(param.source, param.origin);
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: {}});
      }
    });
  }

  private sendGATagOnChangeFunnel(status, facNumber) {
    this.googleTagService.pushTag({
      event: 'event',
      eventCategory: 'gestao_fac',
      eventAction: 'clique:status:fac',
      eventLabel: `status: ${status}`,
      dimension8: facNumber
    });
  }

  private sendTrackingSourceOrigin(source: string, origin: string): void {

    const origins = new Map();
    origins.set('new_lead', 'novo-lead');
    origins.set('fac_transfer', 'nova-fac-recebida-de-transferencia');

    const eventOrigin = origins.get(origin.toLowerCase());
    this.googleTagService.pushTag({
      event: 'callback',
      eventCategory: 'deeplink_open_web',
      eventAction: `origem_${source}`,
      eventLabel: `[tipo-notificação]:${eventOrigin ? eventOrigin : 'indefinido'}`,
    });
  }

r}
